import { faLocationPin } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a location pin icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/location pin?f=classic&s=solid
 */
export const LocationPinIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faLocationPin} {...props} />;
};
